/** − n + ; the only control on the page a customer uses with a thumb. */
export function Qty({ value, onChange, min = 0, compact = false }: { value: number; onChange: (next: number) => void; min?: number; compact?: boolean }) {
  const size = compact ? 'size-8 text-base' : 'size-10 text-lg';
  return (
    <div className="inline-flex items-center rounded-full border border-stone-300 dark:border-stone-700" role="group" aria-label="Quantity">
      <button type="button" aria-label="Less" disabled={value <= min} onClick={() => onChange(Math.max(min, value - 1))} className={`${size} grid place-items-center rounded-full text-stone-700 disabled:opacity-30 dark:text-stone-200`}>
        −
      </button>
      <input
        type="number"
        inputMode="numeric"
        min={min}
        max={999}
        value={value}
        onChange={(e) => onChange(Math.max(min, Math.min(999, Number(e.target.value) || 0)))}
        className="w-10 bg-transparent text-center text-sm font-semibold text-stone-900 outline-none [appearance:textfield] dark:text-stone-100 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      />
      <button type="button" aria-label="More" onClick={() => onChange(Math.min(999, value + 1))} className={`${size} grid place-items-center rounded-full text-stone-700 dark:text-stone-200`}>
        +
      </button>
    </div>
  );
}
